import React from "react";

export default function PrivacyPolicy({ onBack }: { onBack: () => void }) {
  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "32px 20px", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <button onClick={onBack} style={{ background: "none", border: "none", color: "#2d5a27", fontWeight: 600, fontSize: 14, cursor: "pointer", marginBottom: 24, fontFamily: "inherit" }}>
        ← Back
      </button>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: "#6b7280", fontSize: 13, marginBottom: 32 }}>Last updated: March 22, 2026</p>

      <div style={{ fontSize: 15, color: "#374151", lineHeight: 1.7 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>1. Information We Collect</h2>
        <p>When you use Ingrediable, we collect the following information:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li><strong>Account information:</strong> email address and display name when you sign up.</li>
          <li><strong>Inventory data:</strong> food items, quantities, expiry dates, and categories you add.</li>
          <li><strong>Usage data:</strong> pages visited, features used, and general interaction patterns.</li>
          <li><strong>Device information:</strong> browser type, operating system, and screen size.</li>
          <li><strong>Camera data:</strong> barcode images and receipt photos are processed in real-time and are NOT stored on our servers unless you explicitly save them.</li>
        </ul>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li>Provide and improve the Ingrediable service</li>
          <li>Send expiry alerts and notifications</li>
          <li>Generate waste analytics and insights</li>
          <li>Process payments (if you subscribe to a paid plan)</li>
          <li>Send onboarding and product update emails (you can unsubscribe anytime)</li>
        </ul>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>3. Data Sharing</h2>
        <p>We do NOT sell your personal data. We share data only with:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li><strong>Supabase:</strong> our database and authentication provider</li>
          <li><strong>Stripe:</strong> for payment processing (paid plans only)</li>
          <li><strong>PostHog:</strong> for anonymized product analytics</li>
          <li><strong>Sentry:</strong> for error tracking and performance monitoring</li>
        </ul>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>4. Household & Circles Data</h2>
        <p>When you join a household or circle, your inventory data is shared with other members of that group. You can leave a household or circle at any time, which revokes their access to your data.</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>5. Data Retention</h2>
        <p>We retain your data for as long as your account is active. If you delete your account, all personal data is permanently removed within 30 days. Anonymized, aggregated analytics data may be retained indefinitely.</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li><strong>Export your data</strong> — available in Settings → Export My Data</li>
          <li><strong>Delete your account</strong> — available in Settings → Delete Account</li>
          <li><strong>Opt out of analytics</strong> — available in Settings → Privacy</li>
          <li><strong>Unsubscribe from emails</strong> — link included in every email</li>
        </ul>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>7. Security</h2>
        <p>All data is encrypted in transit (TLS 1.3) and at rest. We use Supabase Row Level Security to ensure users can only access their own data. Passwords are hashed using bcrypt.</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>8. Children's Privacy</h2>
        <p>Ingrediable is not intended for children under 13. We do not knowingly collect data from children.</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>9. Changes to This Policy</h2>
        <p>We may update this policy from time to time. We will notify you of significant changes via email or in-app notification.</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 32, marginBottom: 12 }}>10. Contact</h2>
        <p>Questions about this policy? Email us at <a href="mailto:privacy@ingrediable.com" style={{ color: "#2d5a27" }}>privacy@ingrediable.com</a>.</p>
      </div>
    </div>
  );
}
